module.exports = __webpack_public_path__ + "team2.a2b2c32b99a0d204669e.jpg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/team2.jpg
// module id = ../../../../../client/assets/img/team2.jpg
// module chunks = styles